import { createConsumer } from '@rails/actioncable'
import Logger from '@Utils/Logger'

interface AccountChannelData {
  type: string
}

interface SubscribeToAccountParams {
  accountId: number
  onSubscriptionUpdated: () => void
}

let consumer: any = null
let subscription: any = null

export const subscribeToAccount = (params: SubscribeToAccountParams): void => {
  if (consumer) {
    consumer.disconnect()
    consumer = null
    subscription = null
  }

  consumer = createConsumer()
  subscription = consumer.subscriptions.create(
    { channel: 'AccountChannel', account_id: params.accountId },
    {
      connected() {
        Logger.debug('[AccountChannel] Connected')
      },
      rejected() {
        Logger.error(new Error('AccountChannel subscription rejected'), '[AccountChannel] Rejected')
      },
      disconnected() {
        Logger.debug('[AccountChannel] Disconnected')
      },
      received(data: AccountChannelData) {
        Logger.debug('[AccountChannel] Received data:', data)
        if (data.type === 'subscription_updated') {
          params.onSubscriptionUpdated()
        }
      }
    }
  )
}

export const unsubscribeFromAccount = (): void => {
  if (subscription) {
    try {
      subscription.unsubscribe()
    } catch (error) {
      Logger.error(error, '[AccountChannel] Error during unsubscribe')
    }
    subscription = null
  }

  if (consumer) {
    try {
      consumer.disconnect()
    } catch (error) {
      Logger.error(error, '[AccountChannel] Error during disconnect')
    }
    consumer = null
  }
}
